import {grey100} from "material-ui/styles/colors";
import {changeLanguage, loc} from "core/common/config/locales";
import React from "react";
import {ShipmentVisit} from "shipment/shipmentDomain";
import {Step, StepLabel, Stepper} from "material-ui/Stepper";
import {formatDateTime, formatPeriod} from "core/common/utils/dateUtils";
import {lovValue} from "core/form/formUtils";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {Tooltip, OverlayTrigger} from "react-bootstrap";

const __flagStyles = {marginRight: 10, cursor: "pointer"};


export const BigFlagBar = () => (
  <div style={{fontSize: 36, paddingLeft: 10, marginTop: 10, backgroundColor: grey100, alignSelf: "flex-end"}}>
    {
      Object.entries(loc.countries).filter(([lang, country]) => lang !== loc.lang).map(([lang, country]) => {
        return (<span key={lang} onClick={() => changeLanguage(lang, undefined)} className={"flag-icon flag-icon-" + country} style={__flagStyles}/>)
      } )
    }
  </div>
);

const MyTooltip = ( {text, tooltipText}: {text: string, tooltipText: string}) => (
  <OverlayTrigger placement="bottom" delayShow={300} overlay={<Tooltip>{tooltipText}</Tooltip>}>
    <span>{text}</span>
  </OverlayTrigger>
)

export const ShipmentVisitStepper = ({dataObject, entities} : {dataObject: ShipmentVisit, entities: ObservableMap<MdEntity>}) => {

  let shipmentVisitStepLovs = entities.get("SHIPMENTVISITSTEP").lovItems;
  let activeStepNumber = shipmentVisitStepLovs.map(lov => lov.value).indexOf(lovValue(dataObject.step));


  return (
    <Stepper activeStep={activeStepNumber} style={{marginBottom: 20}}>
      <Step>
        <StepLabel className="mui-stepper-icon-hack">
          <div>
            <div style={{fontWeight: "bold"}}>{shipmentVisitStepLovs[0].label}</div>
            <MyTooltip text={dataObject.dateCreated ? formatDateTime(dataObject.dateCreated, "L HH:mm") : ""} tooltipText="Created"/>
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel className="mui-stepper-icon-hack">
          <div>
            <div style={{fontWeight: "bold"}}>{shipmentVisitStepLovs[1].label}</div>
            <div>
              {dataObject.visitTime  && <MyTooltip text={formatDateTime(dataObject.visitTime, "L HH:mm")} tooltipText="Visit time"/>}
              {dataObject.gateLoadingDuration && <MyTooltip text={" (" + formatPeriod(dataObject.gateLoadingDuration, true) + ")"} tooltipText="Gate loading duration"/>}
            </div>
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel className="mui-stepper-icon-hack">
          <div>
            <div style={{fontWeight: "bold"}}>{shipmentVisitStepLovs[2].label}</div>
            <div>
              {dataObject.entranceTime  && <MyTooltip text={formatDateTime(dataObject.entranceTime, "L HH:mm")} tooltipText="Entrance time"/>}
              {dataObject.vendorLoadingDuration && <MyTooltip text={" (" + formatPeriod(dataObject.vendorLoadingDuration, true) + ")"} tooltipText="Vendor loading duration"/>}
            </div>
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel className="mui-stepper-icon-hack">
          <div>
            <div style={{fontWeight: "bold"}}>{shipmentVisitStepLovs[3].label}</div>
            <MyTooltip text={dataObject.visitEnd ? formatDateTime(dataObject.visitEnd, "L HH:mm") : ""} tooltipText="Visit end"/>
          </div>
        </StepLabel>
      </Step>

    </Stepper>
  )
}



// WEBPACK FOOTER //
// ./src/shipment/component/shipmentVisitComps.tsx